import { Box, Drawer } from '@material-ui/core';
import DrawerToolbar from 'common/components/drawer/drawer-toolbar';
import CustomerSummary from './CustomerSummary';

interface Prop {
  open: boolean;
  dealerId: number;
  customerId: number;
  isInvoiceAllowed: boolean;
  isMessengerAllowed: boolean;
  isTaskAllowed: boolean;
  onClose: () => void;
}

const CustomerSummaryDrawer: React.FC<Prop> = ({
  open,
  dealerId,
  customerId,
  isInvoiceAllowed,
  isMessengerAllowed,
  isTaskAllowed,
  onClose,
}) => {
  return (
    <Drawer
      PaperProps={{ style: { width: 'auto', minWidth: '900px', maxWidth: '80%' } }}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}>
      <DrawerToolbar title="Customer Summary" onClose={onClose} />
      <Box p={2}>
        <CustomerSummary
          dealerId={dealerId}
          customerId={customerId}
          isInvoiceAllowed={isInvoiceAllowed}
          isMessengerAllowed={isMessengerAllowed}
          isTaskAllowed={isTaskAllowed}
        />
      </Box>
    </Drawer>
  );
};

export default CustomerSummaryDrawer;
